import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllFinancial } from "../../../../../store/slices/editFinanceSlice";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { setOtheeExpensesData } from "../../../../../store/slices/filteredDataSlice";
import { fetchCompanyProfiles } from "../../../../../store/slices/companyProfileSlice";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
import { fetchLeads, updateLead } from "../../../../../store/slices/leadsSlice";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeAdminSlice";
import { fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { fetchHardwareDescriptions, fetchHardwareProjectTracking } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchDescriptionTasks, fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { hasFeatureAccess } from "../../../../../utils/featureAccessUtils";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
// import SearchSalesGrossProfit from "../PiechartSalesFinance/SearchSalesGrossProfit";
// import SearchedSalesNetMargin from "../PiechartSalesFinance/SearchedSalesNetMargin";
import ActualAllServiceTable from "./ActualAllServiceTable";
import ActualSoftwareTable from "./ActualSoftwareTable";
import ActualInstallationTable from "./ActualInstallationTable";
import ActualHardwareTable from "./ActualHardwareTable";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import { fetchSalesHourlyRates } from "../../../../../store/slices/salesHourlyRateSlice";
import {
    getLoggedSalesUserId,
    getPerdiemAndAverageCostFromExpenses,
    resolveEntityId,
    scopeOtherExpensesForUser,
} from "../../../../../utils/salespersonRatesScope";
// import FinanceGraph from "./FinanceGraph";

const ActualFinaceTable = ({ searchedLeadReports, showTable, searchedLeadReportswithoutyears, onActualDataReady, isViewOnly = false }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const USAComma = CommaConvert();
    const currency = useCurrencySymbol();
    const [calculationTable, setCalculationTable] = useState(false);
    const [TableData, setTableData] = useState([]);
    const [selectedProjectName, setSelectedProjectName] = useState({});

    const getRowKey = (row) =>
      row?.quotationId != null && String(row.quotationId).trim() !== ""
        ? String(row.quotationId).trim()
        : row?.ProjectName ?? "";

    const [currentPage, setCurrentPage] = useState(1);

    const AssociatedRef = useRef(null);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
    const [filteredQuotation, setFilteredQuotation] = useState(null);
    const [GandATax, setGandATax] = useState(15);
    const [taxValue, setTaxValue] = useState(27);

    const { taxes } = useSelector((state) => state.salesTaxes);
    const { projects } = useSelector((state) => state.projects);
    const { profiles } = useSelector(state => state.companyProfile);
    // const { entries } = useSelector((state) => state.workentries);
    // const { items } = useSelector((state) => state.hardwareDescription);
    // const { tasks } = useSelector((state) => state.descriptionTasks);
    // const { quotations } = useSelector((state) => state.hourlyRateQuotation);
    const { employees } = useSelector((state) => state.employees);
    const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
    const groupsFromSlice = useSelector((state) => state.group.group);

    const groupNameById = useMemo(() => {
        const map = new Map();
        const normalize = (v) => String(v ?? "").trim();
        (Array.isArray(groupsFromSlice) ? groupsFromSlice : []).forEach((groupItem) => {
            const id = normalize(groupItem?._id ?? groupItem?.id);
            if (!id) return;
            const name = normalize(
                groupItem?.name ??
                groupItem?.newGroupName ??
                groupItem?.groupName ??
                groupItem?.GroupName ??
                id
            );
            map.set(id, name || id);
        });
        return map;
    }, [groupsFromSlice]);

    const groupIdByName = useMemo(() => {
        const map = new Map();
        groupNameById.forEach((name, id) => map.set(String(name).trim(), id));
        return map;
    }, [groupNameById]);

    const getLeadGroupId = useCallback(
        (lead) => {
            const normalize = (value) => String(value ?? "").trim();
            const fromObject = normalize(lead?.groupid?._id ?? lead?.groupid?.id);
            if (fromObject) return fromObject;
            const fromString = typeof lead?.groupid === "string" ? normalize(lead.groupid) : "";
            if (fromString && groupNameById.has(fromString)) return fromString;
            if (fromString && groupIdByName.has(fromString)) return groupIdByName.get(fromString);
            const fromAssigned = normalize(lead?.AssignedGroup);
            if (fromAssigned && groupIdByName.has(fromAssigned)) return groupIdByName.get(fromAssigned);
            return "";
        },
        [groupNameById, groupIdByName]
    );

    const getQuotedRowGroupId = useCallback(
        (row) => {
            const key = getRowKey(row);
            const proj = projects.find((p) => {
                if (p.quotationId != null && String(p.quotationId).trim() !== "") {
                    return String(p.quotationId).trim() === String(key).trim();
                }
                return (
                    (p.ProjectName || "").trim().toLowerCase() ===
                    (row.ProjectName || "").trim().toLowerCase()
                );
            });
            if (proj) {
                const g = proj.groupid;
                const id = g?._id ?? g?.id ?? (typeof g === "string" ? g : "");
                const normalized = String(id || "").trim();
                if (normalized) return normalized;
            }
            return getLeadGroupId(row);
        },
        [projects, getLeadGroupId]
    );

    const getPlRowGroupId = useCallback(
        (row) => (selectedServiceTypes === "CRM" ? getLeadGroupId(row) : getQuotedRowGroupId(row)),
        [selectedServiceTypes, getLeadGroupId, getQuotedRowGroupId]
    );

    const getPlDisplayGroupName = useCallback(
        (row) => {
            const gid = getPlRowGroupId(row);
            if (gid && groupNameById.has(gid)) return groupNameById.get(gid);
            if (gid) return "";
            return row?.AssignedGroup || "";
        },
        [getPlRowGroupId, groupNameById]
    );

    const [quotedValues, setQuotedValues] = useState({});
    const [actualCostPerServiceByRowKey, setActualCostPerServiceByRowKey] = useState({});
    const ACTUAL_PL_COST_CACHE_KEY = "actual_pl_cost_per_service_by_rowKey_v1";

    useEffect(() => {
        try {
            const raw = typeof localStorage !== "undefined" ? localStorage.getItem(ACTUAL_PL_COST_CACHE_KEY) : null;
            if (!raw) return;
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === "object") {
                setActualCostPerServiceByRowKey(parsed);
            }
        } catch (e) {
            // ignore cache parse errors
        }
    }, []);

    // const [, setSelectedProject] = useState();
    const { data } = useSelector(
        (state) => state.salesHourlyRate
    );
    const [perdiem, setperdiem] = useState(0);
    const [averagecost, setaveragecost] = useState(0);
    const AllServiceTableRef = useRef(null);
    const debounceTimeoutRef = useRef(null);
    const [selectedTab, setSelectedTab] = useState("");
    const [financeDataProject, setfinanceDataProject] = useState([]);
    const [comments, setComments] = useState({});

    const [installtionPersons, setinstallationPersons] = useState([]);
    const [SoftwarePersons, setSoftwarePersons] = useState([]);
    const [CloudPersons, setCloudPersons] = useState([]);
    const [HardwarePersons, setHardwarePersons] = useState([]);
    const { projectTrackingWorkEntries } = useSelector(
        (state) => state.workentries
    );
    const { hardwareProjectTracking } = useSelector(
        (state) => state.hardwareDescription
    );
    const { descriptionProjectTracking } = useSelector(
        (state) => state.descriptionTasks
    );
    const [, setcurrentEmployee] = useState();
    const email = localStorage.getItem("email")
    const [filteredTableData, setFilteredTableData] = useState([]);
  const [quotedproject, setquotedproject] = useState([]);

    // Avoid noisy render-time logs (can amplify render loops in dev)

     useEffect(() => {
         const finalproject = projects.filter(
             (proj) =>
                 proj.isProjecttracking === true && proj.isProjectQuoted === true
         );
          setquotedproject(finalproject)
      
      }, [projects, selectedProjectName]);
    useEffect(() => {
        const employee = employees.find((emp) => emp.EmpEmail === email);
        console.log("fsgsdg", employee)
        setcurrentEmployee(employee)
    }, [email, employees]);
    useEffect(() => {
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareProjectTracking());
        dispatch(fetchEmployees());
        dispatch(fetchSalesHourlyRates());

    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchEmployees());
        dispatch(fetchWorkEntries());
        dispatch(fetchAllProjects());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchDescriptionTasks());
        dispatch(fetchQuotations());
        dispatch(fetchOtherExpenses());
        dispatch(fetchSalesTaxes());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchAllFinancial());
        dispatch(fetchSalesTaxes());
        dispatch(fetchAllProjects());
        dispatch(setOtheeExpensesData())
        dispatch(fetchCompanyProfiles());
        dispatch(fetchOtherExpenses());
    }, [dispatch]);

    const handlerefresh = () => {
        dispatch(fetchLeads());
        dispatch(fetchAllFinancial());
        dispatch(fetchSalesTaxes());
        dispatch(fetchAllProjects());
        dispatch(setOtheeExpensesData())
        dispatch(fetchCompanyProfiles());
        dispatch(fetchOtherExpenses());
    };

    // Add this useEffect after your state declarations
    useEffect(() => {
        if (searchedLeadReports && searchedLeadReports.length > 0) {
            setTableData(searchedLeadReports);
        } else {
            setTableData([]);
        }
    }, [searchedLeadReports]);




    useEffect(() => {
        const filteredProject = projects.filter(
            (proj) => proj.isProjecttracking === true
        );

        const qualifiedGroups = filteredProject.filter((project) => {
            // Must have at least one assigned person
            if (!project?.Assignedperson?.length) return false;

            return project.Assignedperson.every((person) =>
            (
                person.salespersonstatus === "project ongoing" ||
                person.salespersonstatus === "project complete"
            )
            );
        });
        setfinanceDataProject(qualifiedGroups)
    }, [projects]);

    const refsMap = {
        AllServiceTable: AllServiceTableRef,

    };
    const handleTabClick = (tabKey) => {
        setSelectedTab(tabKey);
        setTimeout(() => {
            refsMap[tabKey]?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 100); // slight delay so component mounts first
    };

    const refsAccociatedMap = {
        AllServiceAssociatedTable: AssociatedRef,

    };
    const handleAccociatedTabClick = (tabKey) => {
        setTimeout(() => {
            refsAccociatedMap[tabKey]?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 100); // slight delay so component mounts first
    };




    const [matchedProjects, setMatchedProjects] = useState([]); // always an array
    const [matchedEntries, setMatchedEntries] = useState([]); // ✅ will store matched entries

    useEffect(() => {
        if ((selectedProjectName?.ProjectName || selectedProjectName?.quotationId) && financeDataProject?.length) {
            const matches = financeDataProject.filter((proj) => {
                if (selectedProjectName.quotationId != null && proj.quotationId != null) {
                    return String(proj.quotationId).trim() === String(selectedProjectName.quotationId).trim();
                }
                return (
                    proj.ProjectName?.toLowerCase() ===
                    selectedProjectName.ProjectName?.toLowerCase()
                );
            });

            setMatchedProjects(matches);
        } else {
            setMatchedProjects([]); // reset if no match
        }
    }, [selectedProjectName, financeDataProject]);

    useEffect(() => {
        if (matchedProjects.length && projectTrackingWorkEntries.length) {
            const matchedIds = matchedProjects.map((proj) => proj._id);
            const filteredEntries = projectTrackingWorkEntries.filter((entry) =>
                matchedIds.includes(entry.projectid)
            );

            const matchedPersons = matchedProjects.flatMap((project) =>
                (project.Assignedperson || [])

                    .map((person) => ({
                        ...person,
                        projectid: project._id,
                        ProjectName: project.ProjectName, // optional
                    }))
            );

            const matchedEmployees = employees.filter((employee) =>
                matchedPersons.some(
                    (person) =>
                        person.email?.trim().toLowerCase() ===
                        employee.EmpEmail?.trim().toLowerCase()
                )
            );

            const matchedPeopleEntries = filteredEntries.filter((entry) =>
                matchedEmployees.some(
                    (employee) => employee._id?.trim() === entry.taskownerid?.trim()
                )
            );

            setMatchedEntries(matchedPeopleEntries);
        } else {
            setMatchedEntries([]);
        }
    }, [matchedProjects, projectTrackingWorkEntries, employees]);

    const [matchedHardwareEntries, setMatchedHardwareEntries] = useState([]); // ✅ will store matched entries

    useEffect(() => {
        if (matchedProjects.length && hardwareProjectTracking.length) {
            const matchedIds = matchedProjects.map((proj) => proj._id);
            const filteredEntries = hardwareProjectTracking.filter((entry) =>
                matchedIds.includes(entry.projectid)
            );

            const matchedPersons = matchedProjects.flatMap((project) =>
                (project.Assignedperson || [])

                    .map((person) => ({
                        ...person,
                        projectid: project._id,
                        ProjectName: project.ProjectName, // optional
                    }))
            );

            const matchedEmployees = employees.filter((employee) =>
                matchedPersons.some(
                    (person) =>
                        person.email?.trim().toLowerCase() ===
                        employee.EmpEmail?.trim().toLowerCase()
                )
            );

            const matchedPeopleEntries = filteredEntries.filter((entry) =>
                matchedEmployees.some(
                    (employee) => employee._id?.trim() === entry.taskownerid?.trim()
                )
            );
            setMatchedHardwareEntries(matchedPeopleEntries);
        } else {
            setMatchedHardwareEntries([]);
        }
    }, [matchedProjects, hardwareProjectTracking, employees]);

    useEffect(() => {
        if (matchedHardwareEntries.length) {
            setMatchedEntries(prevEntries => [...prevEntries, ...matchedHardwareEntries]);
        }

    }, [matchedHardwareEntries]);

    const [groupedProj, setGroupedProj] = useState({});
    const [finalMappedEntries, setFinalMappedEntries] = useState([]);

    useEffect(() => {
        if (matchedEntries.length && employees.length) {
            const mapped = matchedEntries.map((entry) => {
                const matchedEmp = employees.find((emp) => emp._id === entry.taskownerid);

                // Check if this is a hardware entry (has hardware-specific properties)
                const isHardwareEntry = entry.hasOwnProperty('assemblepartdescription') ||
                    entry.hasOwnProperty('partno') ||
                    entry.hasOwnProperty('quantity');

                if (isHardwareEntry) {
                    // Map hardware entries
                    return {
                        createdBy: {
                            email: matchedEmp?.EmpEmail || "",
                            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
                            role: matchedEmp?.customRoles || [],
                        },
                        assemblepartdescription: entry.assemblepartdescription,
                        partno: entry.partno,
                        quantity: entry.quantity,
                        unitprice: entry.unitprice,
                        totalprice: entry.totalprice,
                        permonth: entry.permonth,
                        taskstatus: entry.taskstatus,
                        _id: entry._id,
                        taskownerid: entry.taskownerid,
                        TypeService: entry.typeservice || "Hardware", // Use the existing typeservice field
                        projectid: entry.projectid,
                    }
                } else {
                    // Map software/cloud/installation entries (your existing logic)
                    return {
                        createdBy: {
                            email: matchedEmp?.EmpEmail || "",
                            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
                            role: matchedEmp?.customRoles || [],
                        },
                        task: entry.task,
                        hoursassigned: entry.hoursassigned,
                        hoursspent: entry.hoursspent,

                        taskStatus: entry.taskStatus,
                        notes: entry.notes,
                        _id: entry._id,
                        taskownerid: entry.taskownerid,
                        TypeService: entry.typeservice || matchedEmp?.servicetype,
                        projectid: entry.projectid,
                    };
                }
            });

            setFinalMappedEntries(mapped);
        } else {
            setFinalMappedEntries([]);
        }
    }, [matchedEntries, employees]);

    const resolveSalesPersonIdForProject = useCallback(
        (proj) => {
            const lead = (searchedLeadReports || []).find((l) => {
                if (proj.quotationId != null && l.quotationId != null) {
                    return (
                        String(proj.quotationId).trim() ===
                        String(l.quotationId).trim()
                    );
                }
                return (
                    String(l.ProjectName || "")
                        .trim()
                        .toLowerCase() ===
                    String(proj.ProjectName || "")
                        .trim()
                        .toLowerCase()
                );
            });
            const fromLeadCreator = resolveEntityId(lead?.createdBy);
            if (fromLeadCreator) return fromLeadCreator;

            const salesperson = employees.find(
                (emp) => emp.EmpEmail === proj.SalesPersonEmail
            );
            return salesperson ? salesperson._id : null;
        },
        [searchedLeadReports, employees]
    );

    useEffect(() => {
        if (!projects || projects.length === 0 || !employees) return;

        const grouped = {};
        projects.forEach((proj) => {
            const projectKey = (proj.quotationId != null && String(proj.quotationId).trim() !== "")
                ? String(proj.quotationId).trim()
                : proj.ProjectName;
            const typeService = proj.TypeService;
            const projectId = proj._id;

            const matchedEntries = finalMappedEntries.filter(
                (entry) =>
                    entry.TypeService === typeService && entry.projectid === projectId
            );

            if (matchedEntries.length === 0) return;
            const filteredProject = {
                TypeService: proj.TypeService,
                ResourceType: proj.ResourceType,
                ProjectName: proj.ProjectName,
                QuotedValue: proj.ServiceValue,
                WorkEntries: matchedEntries,
                AssignedGroup: proj.AssignedGroup,
                AssignedManagerEmail: proj.AssignedManagerEmail,
                Assignedperson: proj.Assignedperson,
                ProjectID: proj._id,
                ProjectNotes: proj?.ProjectFinanceNotes,
                SalesPersonId: resolveSalesPersonIdForProject(proj),
            };
            if (!grouped[projectKey]) {
                grouped[projectKey] = {};
            }

            if (!grouped[projectKey][typeService]) {
                grouped[projectKey][typeService] = [];
            }

            grouped[projectKey][typeService].push(filteredProject);
        });

        setGroupedProj(grouped);
    }, [projects, employees, finalMappedEntries, resolveSalesPersonIdForProject]);

    const [matchedQuotations, setMatchedQuotations] = useState({});

    useEffect(() => {
        if (!data || !groupedProj) return;



        const updatedGroupedProj = {};

        // Loop through each project
        Object.entries(groupedProj).forEach(([projectName, serviceTypes]) => {
            updatedGroupedProj[projectName] = {};

            // Loop through each TypeService within that project
            Object.entries(serviceTypes).forEach(([typeService, serviceArray]) => {
                // Keep the original service array
                const updatedServiceArray = serviceArray.map((entry) => {
                    // Match quotations where designation includes TypeService
                    const matchedQuotations = data.filter((q) =>
                        q.designation?.toLowerCase().includes(typeService.toLowerCase()) &&
                        q.createdBy === entry.SalesPersonId
                    );
                    return {
                        ...entry,
                        quotationDetails: matchedQuotations, // add new key with matched quotations
                    };
                });

                updatedGroupedProj[projectName][typeService] = updatedServiceArray;
            });
        });

        setMatchedQuotations(updatedGroupedProj);
    }, [data, groupedProj]);
    useEffect(() => {
        const rowKey = getRowKey(selectedProjectName);
        if (!rowKey || !matchedQuotations) return;

        const match = matchedQuotations[rowKey] ?? matchedQuotations[selectedProjectName?.ProjectName];

        if (match) {
            setFilteredQuotation({ [rowKey]: match });
        } else {
            setFilteredQuotation(null); // or {} if you prefer
        }
    }, [selectedProjectName, matchedQuotations]);

    useEffect(() => {
        if (profiles[0]?.subscriptionpackage) {
            setSelectedServiceTypes(profiles[0]?.subscriptionpackage);
        }
    }, [profiles]);



    const itemsPerPage = 10;
    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const currentItems = filteredTableData?.slice(startIdx, endIdx); // Changed from TableData to filteredTableData
    const totalItems = filteredTableData?.length; // Changed from TableData to filteredTableData
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const sortAlphabetically = (targetToSort, order) => {
        const key = `${targetToSort}-${order}`;
        const sortedReports = [...filteredTableData]; // Use TableData instead of searchedLeadReports

        switch (key) {
            case "projectname-az":
                sortedReports.sort((a, b) =>
                    a.ProjectName?.trim()
                        .toLowerCase()
                        .localeCompare(b.ProjectName?.trim().toLowerCase())
                );
                break;

            case "projectname-za":
                sortedReports.sort((a, b) =>
                    b.ProjectName?.trim()
                        .toLowerCase()
                        .localeCompare(a.ProjectName?.trim().toLowerCase())
                );
                break;

            case "groupname-az":
                sortedReports.sort((a, b) =>
                    String(getPlDisplayGroupName(a) || "")
                        .toLowerCase()
                        .localeCompare(String(getPlDisplayGroupName(b) || "").toLowerCase())
                );
                break;

            case "groupname-za":
                sortedReports.sort((a, b) =>
                    String(getPlDisplayGroupName(b) || "")
                        .toLowerCase()
                        .localeCompare(String(getPlDisplayGroupName(a) || "").toLowerCase())
                );
                break;

            case "clientname-az":
                sortedReports.sort((a, b) =>
                    a.ClientName?.trim()
                        .toLowerCase()
                        .localeCompare(b.ClientName?.trim().toLowerCase())
                );
                break;

            case "clientname-za":
                sortedReports.sort((a, b) =>
                    b.ClientName?.trim()
                        .toLowerCase()
                        .localeCompare(a.ClientName?.trim().toLowerCase())
                );
                break;

            default:
                console.error("Invalid Order");
        }

        setFilteredTableData(sortedReports);
    };

    const numericSort = (order) => {
        const sortedReports = [...filteredTableData]; // Use filteredTableData instead of searchedLeadReports
        order === "az"
            ? sortedReports.sort(
                (a, b) => Number(a.QuotedValue) - Number(b.QuotedValue)
            )
            : sortedReports.sort(
                (a, b) => Number(b.QuotedValue) - Number(a.QuotedValue)
            );

        setFilteredTableData(sortedReports);
    };
    useEffect(() => {
        dispatch(fetchLeads());
        dispatch(fetchGroups());
    }, [dispatch]);










    useEffect(() => {
        const userEmail = localStorage.getItem("email");
        const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
        const filteredTaxes = taxes.filter(tax => tax.createdBy === currentEmployee?._id);
        filteredTaxes?.forEach((data) => {
            if (data.taxName === "G&A Expenses") {
                setGandATax(data.taxPercentage);
            } else if (data.taxName === "Tax") {
                setTaxValue(data.taxPercentage);
            }
        });
    }, [taxes, employees]);
    // const [perdiem, setperdiem] = useState(14);
    // const [averagecost, setaveragecost] = useState(17);

    const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);

    useEffect(() => {
        if (!searchedLeadReports || !financeDataProject) return; // guard

        // Find projects that have a match in searchedLeadReports
    const matchedProjects = financeDataProject.filter((row) =>
      searchedLeadReports.some((proj) =>
        row.quotationId != null && proj.quotationId != null
          ? String(row.quotationId).trim() === String(proj.quotationId).trim()
          : row.ProjectName === proj.ProjectName
      )
    );

        setSearchedCalcProjects(matchedProjects);
    }, [searchedLeadReports, financeDataProject]);

    const [mergedProjects, setMergedProjects] = useState([]);

    useEffect(() => {
        if (!searchedCalcProjects) return;

        const newData = searchedCalcProjects.map((proj) => {
            const matchedEntries = projectTrackingWorkEntries.filter(
                (entry) => entry.projectid === proj._id
            );

            const matchedDescriptions = descriptionProjectTracking.filter(
                (task) => task.projectid === proj._id
            );

            const matchedHardware = hardwareProjectTracking.filter(
                (task) => task.projectid === proj._id
            );

            return {
                ProjectName: proj.ProjectName,
                quotationId: proj.quotationId ?? null,
                TaskList: matchedEntries,
                Description: matchedDescriptions,
                TypeService: proj.TypeService,
                HardwareList: matchedHardware,
                Assignedperson: proj.Assignedperson,
                SalesPersonEmail: proj.SalesPersonEmail,
            };
        });

        setMergedProjects(newData);
    }, [searchedCalcProjects, projectTrackingWorkEntries, descriptionProjectTracking, hardwareProjectTracking]);

    const [combinedProjects, setCombinedProjects] = useState([]);

    useEffect(() => {
        if (!mergedProjects || mergedProjects.length === 0) return;

        const projectKey = (p) =>
            p?.quotationId != null && String(p.quotationId).trim() !== ""
                ? String(p.quotationId).trim()
                : p?.ProjectName ?? "";

        const grouped = Object.values(
            mergedProjects.reduce((acc, project) => {
                const key = projectKey(project);
                if (!acc[key]) {
                    acc[key] = {
                        ProjectName: project.ProjectName,
                        quotationId: project.quotationId ?? null,
                        salespersonEmail: project.SalesPersonEmail,
                        TaskList: [],
                        Description: [],
                        HardwareList: [],
                    };
                }

                acc[key].TaskList.push(...(project.TaskList || []));
                acc[key].Description.push(
                    ...(project.Description || [])
                );
                acc[key].HardwareList.push(
                    ...(project.HardwareList || [])
                );

                return acc;
            }, {})
        );

        setCombinedProjects(grouped);
    }, [mergedProjects]);

    const [groupedProjects, setGroupedProjects] = useState([]);

    useEffect(() => {
        if (!combinedProjects?.length || !employees?.length) return;

        const updatedProjects = combinedProjects.map((project) => {
            const enrichWithDesignation = (arr = []) =>
                arr.map((item) => {
                    // Prefer taskownerid first
                    const emp =
                        employees.find((e) => e._id === item.taskownerid) ||
                        employees.find((e) => e._id === item.createdBy);

                    if (emp) {
                        // Only include designation if servicetype or customRoles exist
                        const designationParts = [];
                        if (emp.servicetype) designationParts.push(emp.servicetype);
                        if (emp.customRoles?.length) designationParts.push(emp.customRoles[0]);

                        return {
                            ...item,
                            designation: designationParts.join(" ").trim() || null,
                        };
                    }

                    return { ...item, designation: null };
                });

            return {
                ...project,
                Description: enrichWithDesignation(project.Description),
                TaskList: enrichWithDesignation(project.TaskList),
                HardwareList: enrichWithDesignation(project.HardwareList),
            };
        });

        setGroupedProjects(updatedProjects);
    }, [combinedProjects, employees]);

    const [quotationProjects, setquotationProjects] = useState([]);

    useEffect(() => {
        if (quotationProjects?.length) {
            dispatch(setOtheeExpensesData(quotationProjects))
        }
    }, [dispatch, quotationProjects]);



    useEffect(() => {
        if (!groupedProjects || !data || !employees) return;

        const updatedProjects = groupedProjects.map((project) => {
            // Find the employee based on AssignedManagerEmail
            const assignedEmployee = employees.find(
                (emp) => emp.EmpEmail === project.salespersonEmail
            );

            // If no employee found, return project as is
            if (!assignedEmployee) return project;

            // helper to map arrays and add hourlysalary with filtered quotations
            const enrichWithQuotation = (arr) =>
                arr.map((item) => {
                    if (!item.designation) return {
                        ...item,
                        // ensure defaults exist even when designation missing
                        hourlysalaray: item.hourlysalaray || 0,
                        overheadpercentage: item.overheadpercentage || 0,
                    };

                    // Find quotation that matches both designation AND createdBy matches employee _id
                    const matchedQuote = data.find(
                        (q) => q.designation === item.designation &&
                            q.createdBy === assignedEmployee._id
                    );
                    const hourlysalaray = (item.hourlysalaray ?? (matchedQuote?.hourlysalaray ?? 0)) || 0;
                    const overheadpercentage = (item.overheadpercentage ?? (matchedQuote?.overheadpercentage ?? 0)) || 0;

                    return {
                        ...item,
                        hourlysalaray,
                        overheadpercentage,
                    };
                });

            return {
                ...project,
                TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
                Description: project.Description
                    ? enrichWithQuotation(project.Description)
                    : [],
                HardwareList: project.HardwareList
                    ? enrichWithQuotation(project.HardwareList)
                    : [],
            };
        });

        setquotationProjects(updatedProjects);
    }, [groupedProjects, data, employees]);
    const [, setInstallationDescriptions] = useState([]);

    useEffect(() => {
        if (!quotationProjects || quotationProjects.length === 0) return;

        const filteredProjects = quotationProjects
            .map((proj) => {
                const matchedDescriptions = (proj.Description || []).filter(
                    (desc) =>
                        desc.typeservice &&
                        desc.typeservice.toLowerCase().includes("installation") &&
                        desc.designation &&
                        desc.designation.toLowerCase().includes("operations")
                );

                if (matchedDescriptions.length > 0) {
                    return {
                        ProjectName: proj.ProjectName,
                        Description: matchedDescriptions,
                    };
                }
                return null;
            })
            .filter(Boolean); // remove nulls

        setInstallationDescriptions(filteredProjects);
    }, [quotationProjects]);

    const [calculatedProjects, setCalculatedProjects] = useState([]);

    const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);
    const plEmail = typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
    const loggedUserIdForExpenses = useMemo(
        () => getLoggedSalesUserId(loggedInUserId, employees, plEmail),
        [loggedInUserId, employees, plEmail]
    );

    useEffect(() => {
        const expensesForUser = scopeOtherExpensesForUser(otherExpenses, {
            loggedUserId: loggedUserIdForExpenses,
        });
        const { perdiem: p, averagecost: a } =
            getPerdiemAndAverageCostFromExpenses(expensesForUser);
        setperdiem(p);
        setaveragecost(a);
    }, [otherExpenses, loggedUserIdForExpenses]);
    useEffect(() => {
        if (!quotationProjects || quotationProjects.length === 0) return;

        const newData = quotationProjects.map((proj) => {
            let taskValue = 0;
            let descriptionValue = 0;
            let hardwareValue = 0;

            // ✅ TaskList calculation
            if (proj.TaskList?.length > 0) {
                const hoursByOwner = {};

                proj.TaskList.forEach((task) => {
                    if (task.taskownerid && task.hoursassigned) {
                        if (!hoursByOwner[task.taskownerid]) {
                            hoursByOwner[task.taskownerid] = {
                                totalHours: 0,
                                hourlyRate: task.hourlysalaray || 0
                            };
                        }
                        hoursByOwner[task.taskownerid].totalHours += task.hoursassigned;
                    }
                });

                Object.values(hoursByOwner).forEach((ownerData) => {
                    taskValue += ownerData.totalHours * ownerData.hourlyRate;
                });
            }

            // ✅ Description calculation with Installation service condition
            if (proj.Description?.length > 0) {
                // Create a map to track trip duration per taskownerid for Installation services
                const installationTripByOwner = {};

                proj.Description.forEach((desc) => {


                    // For Installation services, track trip duration per owner
                    if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
                        desc.taskownerid && desc.tripduration) {
                        if (!installationTripByOwner[desc.taskownerid]) {
                            installationTripByOwner[desc.taskownerid] = desc.tripduration;
                        } else {
                            // Use the maximum trip duration for each owner
                            installationTripByOwner[desc.taskownerid] =
                                Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
                        }
                    }

                    // Add the normal value calculation
                    if (desc.value) {
                        descriptionValue += desc.value;
                    }
                });

                // Add Installation trip duration calculations (per diem + other expenses)
                Object.values(installationTripByOwner).forEach((tripDuration) => {
                    // Assuming you have state variables called perdiem and otherExpense
                    descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
                });
            }

            // ✅ HardwareList calculation
            if (proj.HardwareList?.length > 0) {
                proj.HardwareList.forEach((hw) => {
                    if (hw.totalprice) {
                        hardwareValue += hw.totalprice;
                    }
                });
            }

            return {
                ProjectName: proj.ProjectName,
                quotationId: proj.quotationId ?? null,
                TaskListValue: taskValue,
                DescriptionValue: descriptionValue,
                HardwareListValue: hardwareValue,
            };
        });

        setCalculatedProjects(newData);
    }, [quotationProjects, perdiem, averagecost]);

    const showExpensesop = useCallback((row) => {
        const rowKey = getRowKey(row);
        if (!rowKey) return "0";

        // Source of truth for Actual Expenses: Itemized P&L "Total Cost Per Service" total (when available).
        const fromItemized = actualCostPerServiceByRowKey?.[String(rowKey).trim()];
        if (fromItemized !== undefined && fromItemized !== null) {
            return `${USAComma(fromItemized)}`;
        }

        const projectsGroupedByKey = financeDataProject.reduce((acc, project) => {
            const key = getRowKey(project);
            const existingGroup = acc.find((g) => g.key === key);
            if (existingGroup) {
                existingGroup.Projects.push(project);
            } else {
                acc.push({
                    key,
                    ProjectName: project.ProjectName,
                    Projects: [project],
                });
            }
            return acc;
        }, []);

        const isQualifiedProject = projectsGroupedByKey.some(
            (group) => group.key === rowKey
        );
        if (!isQualifiedProject) {
            return "0";
        }

        const matchedProjectfinal = quotationProjects.find(
            (proj) => getRowKey(proj) === rowKey
        );
        if (!matchedProjectfinal) {
            return "0";
        }
        const projectExistsInQuoted = quotedproject?.some(
            (qp) => getRowKey(qp) === rowKey
        );

        const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
            // Match Itemized P&L: use assigned hours for efforts (Hours × Hourly Rate)
            const hours = Number(task.hoursassigned ?? task.hoursspent) || 0;

            let hourlyRate = 0;

            // Only use quotedprject logic if project exists in quotedprject
            if (projectExistsInQuoted) {
                // Find the specific quoted project for this task
                const taskQuotedProject = quotedproject?.find(qp =>
                    qp._id === task.projectid
                );

                if (taskQuotedProject) {
                    const isManager = task.designation?.toLowerCase().includes('manager');
                    const isOperations = task.designation?.toLowerCase().includes('operations');

                    if (isManager) {
                        hourlyRate = taskQuotedProject.managerHourlyRate || 0;
                    } else if (isOperations) {
                        hourlyRate = taskQuotedProject.operationHourlyRate || 0;
                    }

                    // If still no rate found, fall back to old logic
                    if (hourlyRate === 0) {
                        // Match Itemized P&L: hourly salary only (no overhead addition)
                        hourlyRate = Number(task.hourlysalaray) || 0;
                    }
                } else {
                    // If quoted project not found for this specific task, use old logic
                    hourlyRate = Number(task.hourlysalaray) || 0;
                }
            } else {
                // Project not in quotedprject, use old logic
                hourlyRate = Number(task.hourlysalaray) || 0;
            }

            const taskValue = hours * hourlyRate;
            return total + taskValue;
        }, 0);

        // const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
        //     const hoursSpent = Number(task.hoursspent) || 0;
        //     const hourlySalary = Number(task.hourlysalaray) || 0;
        //     const overhead = Number(task.overheadpercentage) || 0;

        //     // ✅ Overhead is a direct addition, not a percentage
        //     const effectiveHourlySalary = hourlySalary + overhead;

        //     const taskValue = hoursSpent * effectiveHourlySalary;

        //     return total + taskValue;
        // }, 0);

        let descriptionValue = 0;

        if (matchedProjectfinal.Description?.length > 0) {
            // Create a map to track trip duration per taskownerid for Installation services
            const installationTripByOwner = {};

            matchedProjectfinal.Description.forEach((desc) => {


                // For Installation services, track trip duration per owner
                if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
                    desc.taskownerid && desc.tripduration) {
                    if (!installationTripByOwner[desc.taskownerid]) {
                        installationTripByOwner[desc.taskownerid] = desc.tripduration;
                    } else {
                        // Use the maximum trip duration for each owner
                        installationTripByOwner[desc.taskownerid] =
                            Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
                    }
                }

                // Match Itemized P&L: associated cost can come as `expenses` or `value`
                const exp = Number(desc.expenses ?? desc.value ?? 0) || 0;
                if (exp) descriptionValue += exp;
            });

            // Add Installation trip duration calculations (per diem + other expenses)
            Object.values(installationTripByOwner).forEach((tripDuration) => {
                // Assuming you have state variables called perdiem and otherExpense
                descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
            });
        }

        let hardwareValue = 0;
        

        if (matchedProjectfinal.HardwareList?.length > 0) {
            const hardwareByDescription = {};

            // Group hardware by assemblepartdescription and keep only the one with highest totalprice
            matchedProjectfinal.HardwareList.forEach((hw) => {
                const description = hw.assemblepartdescription;

                if (!hardwareByDescription[description]) {
                    hardwareByDescription[description] = hw;
                } else {
                    // If we already have this description, keep the one with higher totalprice
                    if (hw.totalprice > hardwareByDescription[description].totalprice) {
                        hardwareByDescription[description] = hw;
                    }
                }
            });

            // Calculate total hardware value using only the highest totalprice items
            Object.values(hardwareByDescription).forEach((hw) => {
                if (hw.totalprice) {
                    hardwareValue += hw.totalprice;
                }
            });
        }

        // Actual P&L: "Actual Expenses" must match Itemized P&L "Total Cost Per Service" total.
        // Itemized totals are Total Efforts + Associated Cost (description/hardware/expenses).
        const grandTotal = totalTaskValue + descriptionValue + hardwareValue;

        return `${USAComma(grandTotal)}`;
    }, [actualCostPerServiceByRowKey, financeDataProject, quotationProjects, quotedproject, perdiem, averagecost, USAComma]);

    const handleActualTotalCostPerServiceTotalChange = useCallback((projectKey, totalCostPerService) => {
        const key = String(projectKey ?? "").trim();
        if (!key) return;
        const total = Math.round(Number(totalCostPerService) || 0);
        setActualCostPerServiceByRowKey((prev) => {
            const next = { ...(prev || {}) };
            next[key] = total;
            try {
                if (typeof localStorage !== "undefined") {
                    localStorage.setItem(ACTUAL_PL_COST_CACHE_KEY, JSON.stringify(next));
                }
            } catch (e) {
                // ignore storage quota / access errors
            }
            return next;
        });
    }, []);

    const localActualTotal = useMemo(() => {
        if (!filteredTableData || filteredTableData.length === 0) return 0;
        return filteredTableData.reduce((sum, row) => {
            const costStr = showExpensesop(row);
            return sum + (parseFloat(String(costStr || "0").replace(/[,$]/g, "")) || 0);
        }, 0);
    }, [filteredTableData, showExpensesop]);

    // Prevent maximum update depth loops when parent passes an unstable callback.
    const onActualDataReadyRef = useRef(onActualDataReady);
    useEffect(() => {
        onActualDataReadyRef.current = onActualDataReady;
    }, [onActualDataReady]);

    useEffect(() => {
        const cb = onActualDataReadyRef.current;
        if (typeof cb !== "function") return;
        if (filteredTableData.length > 0) {
            cb(filteredTableData, localActualTotal);
        } else {
            cb([], 0);
        }
    }, [filteredTableData, localActualTotal]);

    useEffect(() => {
        if (searchedLeadReports.length > 0) {
            const initialValues = {};
            const initialComments = {};

            searchedLeadReports.forEach((lead) => {
                const key = getRowKey(lead);
                initialValues[key] = lead.QuotedValue || 0;
                initialComments[key] = lead.projectnotes || "";
            });
            setQuotedValues(initialValues);
            setComments(initialComments);
        }
    }, [searchedLeadReports]);

    // const handleQuotedValueChange = (row, value) => {
    //     // Handle empty string case by setting to 0
    //     const numericValue = value === "" ? 0 : parseFloat(value) || 0;

    //     // Update state immediately
    //     setQuotedValues(prev => ({
    //         ...prev,
    //         [row.ProjectName]: numericValue
    //     }));

    //     // Clear previous timeout if it exists
    //     if (debounceTimeoutRef.current) {
    //         clearTimeout(debounceTimeoutRef.current);
    //     }

    //     // Set new timeout to call Submit after 1 second
    //     debounceTimeoutRef.current = setTimeout(() => {
    //         // Pass the numericValue directly instead of relying on state
    //         Submit(row, numericValue);
    //     }, 500);
    // };

    // Derive filtered table data idempotently to avoid render loops when dependencies are noisy.
    const lastFilteredSigRef = useRef("");
    useEffect(() => {
        const next = (TableData && TableData.length > 0)
            ? TableData.filter((row) => showExpensesop(row) !== "0")
            : [];

        const sig = next.map((r) => getRowKey(r)).join("|");
        if (sig === lastFilteredSigRef.current) return;
        lastFilteredSigRef.current = sig;

        setFilteredTableData(next);
        setCurrentPage(1);
    }, [TableData, showExpensesop]);





    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);

    // const Submit = async (selectedProject, newValue) => {

    //     try {
    //         const updatedLeadData = {
    //             QuotedValue: newValue, // Use the passed value instead of state
    //             ProjectName: selectedProject.ProjectName,
    //         };

    //         await dispatch(
    //             updateLead({ id: selectedProject.id, updatedData: updatedLeadData })
    //         ).unwrap();

    //         dispatch(fetchLeads());
    //         enqueueSnackbar("Quoted Value Updated Successfully", {
    //             variant: "success",
    //         });

    //     } catch (error) {
    //         console.error("Error:", error);
    //     } finally {
    //         handlerefresh()
    //     }
    // };





    const calculateGrossProfit = (row) => {
        const rowKey = getRowKey(row);
        const quotedValue = quotedValues[rowKey] ?? quotedValues[row?.ProjectName] ?? 0;
        const expenseStr = showExpensesop(row);
        const expense = parseFloat(String(expenseStr || "0").replace(/,/g, "")) || 0;
        return quotedValue - expense;
    };

    const handleCommentsChange = (row, value) => {
        const key = getRowKey(row);
        setComments((prev) => ({
            ...prev,
            [key]: value,
        }));

        // Clear previous timeout if it exists
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        // Set new timeout to call API after 1 second (debounce)
        debounceTimeoutRef.current = setTimeout(() => {
            updateComments(row, value);
        }, 1000);
    };

    const updateComments = async (selectedProject, newComment) => {
        try {
            const updatedLeadData = {
                projectnotes: newComment,
                ProjectName: selectedProject.ProjectName,
            };

            await dispatch(
                updateLead({ id: selectedProject.id, updatedData: updatedLeadData })
            ).unwrap();

            dispatch(fetchLeads());
            enqueueSnackbar("Notes Updated Successfully", {
                variant: "success",
            });

        } catch (error) {
            console.error("Error updating Notes:", error);
            enqueueSnackbar("Error updating Notes", {
                variant: "error",
            });
        }
    };


    return (
        <div className="rounded-md ">
            <div className="relative  scroll-visible justify-center top-0">
                <div className="">
                    <div>
                        <div className="w-full max-h-[80vh] overflow-auto bg-white">
                            <div className="w-full head sticky top-0 z-10 h-12 flex text-black bg-[#E8E8E8] font-semibold">
                                <div className="flex-shrink-0 w-10 px-3 py-3 flex items-start justify-center text-center text-xs  tracking-wider bg-[#E8E8E8] sticky left-0 z-20">
                                    Sr. No
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex gap-2  justify-between align-middle items-center text-start  text-xs tracking-wider capitalize bg-[#E8E8E8] sticky left-[40px] z-20">
                                    Group Name
                                    <div className="flex flex-col gap-y-1">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                sortAlphabetically("groupname", "az")
                                            }
                                        >
                                            <ArrowDropUp
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>

                                        <div
                                            className="cursor-pointer -mt-2"
                                            onClick={() =>
                                                sortAlphabetically("groupname", "za")
                                            }
                                        >
                                            <ArrowDropDown
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex gap-2  justify-between align-middle items-center text-start  text-xs tracking-wider capitalize bg-[#E8E8E8] sticky left-[216px] z-20">
                                    Client Name
                                    <div className="flex flex-col gap-y-1">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                sortAlphabetically("clientname", "az")
                                            }
                                        >
                                            <ArrowDropUp
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>

                                        <div
                                            className="cursor-pointer -mt-2"
                                            onClick={() =>
                                                sortAlphabetically("clientname", "za")
                                            }
                                        >
                                            <ArrowDropDown
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex gap-2  justify-between align-middle items-center text-start  text-xs tracking-wider capitalize bg-[#E8E8E8] sticky left-[392px] z-20">
                                    Project Name
                                    <div className="flex flex-col gap-y-1">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() =>
                                                sortAlphabetically("projectname", "az")
                                            }
                                        >
                                            <ArrowDropUp
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>

                                        <div
                                            className="cursor-pointer -mt-2"
                                            onClick={() =>
                                                sortAlphabetically("projectname", "za")
                                            }
                                        >
                                            <ArrowDropDown
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 gap-2 flex justify-center align-middle items-center text-center  text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    Quoted Price({currency})
                                    <div className="flex flex-col gap-y-1">
                                        <div
                                            className="cursor-pointer"
                                            onClick={() => numericSort("za")}
                                        >
                                            <ArrowDropUp
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>

                                        <div
                                            className="cursor-pointer -mt-2"
                                            onClick={() => numericSort("az")}
                                        >
                                            <ArrowDropDown
                                                color="white"
                                                sx={{ fontSize: "22px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex justify-center align-middle items-center text-center text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    {selectedServiceTypes === "ERP" ? `Actual Expenses(${currency})` : `Quoted Expenses(${currency})`}
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex justify-center align-middle items-center text-center text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    Gross Profit({currency})
                                </div>
                                <div className="flex-shrink-0 w-44 px-3 py-3 flex justify-center align-middle items-center text-center text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    G&A Expenses({currency})
                                </div>
                                {/* <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                      EBIT ({currency})
                    </div> */}
                                <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center  text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    Tax({currency})
                                </div>
                                <div className="flex-shrink-0 w-44 flex flex-col justify-center align-middle items-center text-center  text-xs tracking-wider capitalize bg-[#E8E8E8]">
                                    <div className="h-[50%] w-full flex justify-center align-middle items-center"> Net Revenue</div>
                                    <div className="h-[50%] flex w-full">
                                        <div className="w-[50%] border flex justify-center align-middle items-center">({currency})</div>
                                        <div className="w-[50%] border flex justify-center align-middle items-center">(%)</div>
                                    </div>

                                </div>
                                <div className="flex-shrink-0 w-28 px-3 py-3 flex justify-center align-middle items-center text-center  text-xs  tracking-wider capitalize bg-[#E8E8E8]">
                                    Notes
                                </div>
                                {/* <div className="flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium  tracking-wider capitalize bg-black">
                                    Quotation

                                </div> */}
                            </div>

                            <div className="w-full">
                                {currentItems?.filter(row => showExpensesop(row) !== "0").length === 0 ? (
                                    <div className=" bg-white w-full flex justify-center items-center py-5">
                                        <div className="text-red-500 text-lg font-semibold">
                                            No data available
                                        </div>
                                    </div>
                                ) : (
                                    currentItems?.filter(row => showExpensesop(row) !== "0").map((row, index) => (
                                        <>
                                            <div key={index} className={`CRMandERPtableone w-full flex h-10`}>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} className={`flex-shrink-0 w-10 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white  px-3 py-3 flex items-center justify-start text-start border-b text-xs tracking-wider sticky left-0 z-[5]`}>
                                                    {startIdx + index + 1}
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} title={(getPlDisplayGroupName(row) || "Click To View Finance Details")}
                                                    className={`flex-shrink-0 w-44 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} px-3 py-3 flex gap-2  justify-start align-middle items-center text-start border-b text-xs tracking-wider capitalize sticky left-[40px] z-[5]`}
                                                >
                                                    {getPlDisplayGroupName(row)}

                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} title="Click To View Finance Details"
                                                    className={`flex-shrink-0 w-44 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white px-3 py-3 flex gap-2  justify-start align-middle items-center text-start border-b text-xs tracking-wider capitalize sticky left-[216px] z-[5]`}
                                                >
                                                    {row.ClientName}

                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} title="Click To View Finance Details"
                                                    className={`flex-shrink-0 w-44 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white px-3 py-3 flex gap-2  justify-start align-middle items-center text-start border-b text-xs tracking-wider capitalize sticky left-[392px] z-[5]`}
                                                >
                                                    {row.ProjectName}

                                                </div>
                                                <div className={`flex-shrink-0 w-44 p-2 gap-2 flex justify-center bg-white align-middle items-center text-start border-b text-xs  tracking-wider capitalize `}>
                                                    {USAComma(row.QuotedValue)}
                                                    {/* <input
                                                        type="text"
                                                        title="Enter Quoted Value"
                                                        className={`text-center pl-2 h-full w-[70%] outline-none border border-black rounded-md bg-[#cfecf7]`}
                                                        value={`${USAComma(quotedValues[getRowKey(row)] || row.QuotedValue || 0)}`}
                                                        onChange={(e) => {
                                                            // Remove only commas for processing, keep the dollar sign
                                                            const val = e.target.value.replace(/,/g, "");
                                                            handleQuotedValueChange(row, val.replace(/\$/g, ""));
                                                        }}
                                                        onFocus={(e) => {
                                                            // Select all text when focused for easy editing, but keep the dollar sign
                                                            e.target.select();
                                                        }}
                                                        onBlur={(e) => {
                                                            // Ensure proper formatting when focus is lost
                                                            const val = e.target.value;
                                                            if (val) {
                                                                const numericValue = parseFloat(val.replace(/,/g, "").replace(/\$/g, ""));
                                                                if (!isNaN(numericValue)) {
                                                                    e.target.value = `${currency}${USAComma(numericValue)}`;

                                                                    // Update the state with the formatted value
                                                                    setQuotedValues(prev => ({
                                                                        ...prev,
                                                                        [getRowKey(row)]: numericValue
                                                                    }));
                                                                }
                                                            }
                                                        }}
                                                        onKeyDown={(e) => {
                                                            // Allow only numbers, decimal point, and navigation keys
                                                            if (!/[\d.]|Arrow|Delete|Backspace|Tab|Enter/.test(e.key) &&
                                                                !e.ctrlKey && !e.metaKey) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    /> */}
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }}
                                                    className={`quotedExpense ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white relative group flex-shrink-0 w-44 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize`}>

                                                    {showExpensesop(row)}

                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} className={`GrossProfit flex-shrink-0 w-44 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all 
    ${calculateGrossProfit(row) < 0 ? "text-red-500" : "text-green-500"}`}
                                                >
                                                    {USAComma(calculateGrossProfit(row))}
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} className={`G&AExpenses flex-shrink-0 w-44 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all 
    ${calculateGrossProfit(row) * (GandATax / 100) < 0 ? "text-red-500" : "text-black"}`}
                                                >
                                                    {USAComma(calculateGrossProfit(row) * (GandATax / 100))}
                                                </div>

                                                {/* <div
                              className={`EBIT flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border text-xs font-medium tracking-wider capitalize text-wrap break-all
  
    ${calculateGrossProfit(row) - (calculateGrossProfit(row) * (GandATax / 100)) < 0 ? "text-red-500" : "text-black"}`}
                            >
                              ${USAComma(
                                calculateGrossProfit(row) -
                                calculateGrossProfit(row) * (GandATax / 100)
                              )}
                            </div> */}

                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }}
                                                    className={`Tax flex-shrink-0 w-24 ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all
    
    ${calculateGrossProfit(row) * (taxValue / 100) < 0 ? "text-red-500" : "text-black"}`}
                                                >
                                                    {USAComma(calculateGrossProfit(row) * (taxValue / 100))}
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        if (isViewOnly) return;
                                                        if (showExpensesop(row) !== "0") {
                                                            setSelectedProjectName(row);
                                                            setCalculationTable(true);

                                                        }
                                                        handleTabClick("AllServiceTable")
                                                    }} className={`flex-shrink-0 w-44 flex ${isViewOnly ? "cursor-not-allowed pointer-events-none" : showExpensesop(row) !== "0" ? "cursor-pointer" : ""} bg-white justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize text-wrap break-all`}>
                                                    <div
                                                        className={`NetRevenue w-[50%]  flex justify-center align-middle items-center text-wrap break-all
    ${(
                                                                (calculateGrossProfit(row) - (calculateGrossProfit(row) * (GandATax / 100))) -
                                                                (calculateGrossProfit(row) * (taxValue / 100))
                                                            ) < 0 ? "text-red-500" : "text-black"}`}
                                                    >
                                                        {USAComma(
                                                            (calculateGrossProfit(row) -
                                                                calculateGrossProfit(row) * (GandATax / 100)) -
                                                            calculateGrossProfit(row) * (taxValue / 100)
                                                        )}
                                                    </div>

                                                    <div
                                                        className={`NetRevenuePercentage w-[50%] flex justify-center align-middle items-center text-wrap break-all
    ${(
                                                                (
                                                                    (
                                                                        (calculateGrossProfit(row) -
                                                                            calculateGrossProfit(row) * (GandATax / 100)) -
                                                                        calculateGrossProfit(row) * (taxValue / 100)
                                                                    ) /
                                                                    quotedValues[getRowKey(row)]
                                                                ) * 100
                                                            ) < 0 ? "text-red-500" :
                                                                (
                                                                    (
                                                                        (
                                                                            (calculateGrossProfit(row) -
                                                                                calculateGrossProfit(row) * (GandATax / 100)) -
                                                                            calculateGrossProfit(row) * (taxValue / 100)
                                                                        ) /
                                                                        quotedValues[getRowKey(row)]
                                                                    ) * 100
                                                                ) < 10 ? "text-orange-600" :
                                                                    "text-black"}`}
                                                    >
                                                        {(() => {
                                                            const grossProfit = calculateGrossProfit(row);
                                                            const quotedValue = quotedValues[getRowKey(row)];

                                                            const value =
                                                                ((grossProfit - grossProfit * (GandATax / 100) - grossProfit * (taxValue / 100)) /
                                                                    quotedValue) *
                                                                100;

                                                            return isFinite(value) && !isNaN(value) ? value.toFixed(2) : "0";
                                                        })()}
                                                        {/* {(
                                                        (
                                                            (
                                                                (calculateGrossProfit(row) -
                                                                    calculateGrossProfit(row) * (GandATax / 100)) -
                                                                calculateGrossProfit(row) * (taxValue / 100)
                                                            ) /
                                                            quotedValues[getRowKey(row)]
                                                        ) * 100
                                                    ).toFixed(2)} */}
                                                    </div>

                                                </div>
                                                <div
                                                    className={`flex-shrink-0 p-3 w-28 break-words bg-white text-wrap flex justify-center items-center text-center border-b text-xs tracking-wider capitalize`}
                                                >
                                                    <textarea
                                                        className={`leadComments w-28 h-full outline-none text-center break-words whitespace-normal ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-white"} resize-none overflow-x-hidden`}
                                                        value={comments[getRowKey(row)] || ""}
                                                        onChange={(e) => handleCommentsChange(row, e.target.value)}
                                                        placeholder="Enter Notes"
                                                        disabled={isViewOnly}
                                                    />

                                                </div>

                                                {/* <div
                                                title="Generate Quotation"
                                                onClick={() => {
                                                    // setShowQuoteModal(true);
                                                    setSelectedProject(row);
                                                }}
                                                className={`flex-shrink-0 cursor-pointer w-24 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs font-medium  tracking-wider capitalize`}>
                                                <TextSnippetIcon className="w-5 h-5 "
                                                />
                                            </div> */}
                                            </div>
                                        </>
                                    )))}
                            </div>
                        </div>
                    </div>

                    <div className="pagination border flex justify-between items-center bg-white pt-2 pb-2 p-1 rounded-b-md mb-2">
                        <div>
                            {totalItems > 0 ? (
                                <>
                                    Showing {startIdx + 1} to {Math.min(endIdx, totalItems)}{" "}
                                    of {totalItems} Entries
                                </>
                            ) : (
                                <>Showing 0 Entries</>
                            )}
                        </div>
                        {totalPages > 1 && (
                            <div>
                                <button
                                    onClick={() => setCurrentPage(1)}
                                    className="px-2 py-2 mx-1 border rounded"
                                    disabled={currentPage === 1}
                                    title="First Page"
                                >
                                    <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                                </button>
                                <button
                                    onClick={() =>
                                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                                    }
                                    className="px-2 py-2 mx-2 border rounded"
                                    disabled={currentPage === 1}
                                >
                                    <ChevronRightIcon className="w-5 h-5 rotate-180" />

                                    {/* Previous */}
                                </button>

                                {Array.from({ length: 3 }, (_, index) => {
                                    // Calculate the page number for the current range
                                    const pageNumber = currentPage - 1 + index;

                                    // Ensure the pageNumber stays within bounds
                                    if (pageNumber >= 1 && pageNumber <= totalPages) {
                                        return (
                                            <button
                                                key={pageNumber}
                                                onClick={() => setCurrentPage(pageNumber)}
                                                className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                                                    }`}
                                            >
                                                {pageNumber}
                                            </button>
                                        );
                                    }

                                    // Return null for out-of-bounds values
                                    return null;
                                })}

                                <button
                                    onClick={() =>
                                        setCurrentPage((prev) =>
                                            Math.min(prev + 1, totalPages)
                                        )
                                    }
                                    className="px-2 py-2 mx-2 border rounded"
                                    disabled={currentPage === totalPages}
                                >
                                    <ChevronRightIcon className="w-5 h-5" />

                                    {/* Next */}
                                </button>

                                <button
                                    onClick={() => setCurrentPage(totalPages)}
                                    className="px-2 py-2 mx-1 border rounded"
                                    disabled={currentPage === totalPages}
                                    title="Last Page"
                                >
                                    <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                                </button>
                            </div>
                        )}
                    </div>


                    {calculationTable && (
                        selectedTab === "AllServiceTable" && (
                            <div className="mb-2">
                                <div ref={AllServiceTableRef}>
                                    <ActualAllServiceTable
                                        handlerefresh={handlerefresh}
                                        filteredQuotation={filteredQuotation}
                                        selectedProject={selectedProjectName}
                                        projects={projects}
                                        calculatedProjects={calculatedProjects}
                                        handleAccociatedTabClick={handleAccociatedTabClick}
                                        setinstallationPersons={setinstallationPersons}
                                        setSoftwarePersons={setSoftwarePersons}
                                        setCloudPersons={setCloudPersons}
                                        setHardwarePersons={setHardwarePersons}
                                        tasks={descriptionProjectTracking}
                                        items={hardwareProjectTracking}
                                        onTotalCostPerServiceTotalChange={handleActualTotalCostPerServiceTotalChange}
                                    />
                                </div>

                                {/* For Hardware */}
                                {HardwarePersons.length ? (
                                    <div className="bg-white mt-2 rounded-md">

                                        <ActualHardwareTable items={hardwareProjectTracking} AssociatedRef={AssociatedRef} currentPerson={HardwarePersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={descriptionProjectTracking} selectedProject={selectedProjectName} />
                                    </div>
                                ) : (
                                    <> </>
                                )}
                                {/* For Installation */}
                                {installtionPersons.length ? (
                                    <div className="bg-white mt-2 rounded-md">

                                        <ActualInstallationTable
                                          tasks={descriptionProjectTracking}
                                          AssociatedRef={AssociatedRef}
                                          currentPerson={installtionPersons}
                                          filteredQuotation={filteredQuotation}
                                          matchedProjects={matchedProjects}
                                          perdiemRate={perdiem}
                                          averageCostRate={averagecost}
                                        />
                                    </div>
                                ) : (
                                    <> </>
                                )}
                                {/* For software */}
                                {SoftwarePersons.length ? (
                                    <div className="bg-white mt-2 rounded-md">

                                        <ActualSoftwareTable AssociatedRef={AssociatedRef} currentPerson={SoftwarePersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={descriptionProjectTracking} selectedProject={selectedProjectName} />
                                    </div>
                                ) : (
                                    <> </>
                                )}
                                {/* for  Cloud  */}
                                {CloudPersons.length ? (
                                    <div className="bg-white mt-2 rounded-md">

                                        <ActualSoftwareTable AssociatedRef={AssociatedRef} currentPerson={CloudPersons} filteredQuotation={filteredQuotation} matchedProjects={matchedProjects} tasks={descriptionProjectTracking} selectedProject={selectedProjectName} />
                                    </div>
                                ) : (
                                    <> </>
                                )}
                            </div>
                        )
                    )}

                </div>
            </div>
        </div >
    )
}

export default ActualFinaceTable